import React, { Component } from 'react';
import { Button } from "@mui/material";
import { AddShoppingCart } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';


interface props {
    loading: boolean;
    disabled: boolean;
    onPress: () => any;
    noMargin?: boolean;
    color?: string;
}

export default class AddToCartSmallBtn extends Component<props, {}> {

    render() {
        return (
            <Button
                onClick={this.handlePress}
                disabled={this.getDisabled()}
                variant="contained"
                startIcon={this.getIcon()}
                style={{ marginTop: "1%", marginBottom: this.props.noMargin !== undefined && this.props.noMargin ? '0%' : '5%', zIndex: 2, padding: '6px 16px', color:"black", backgroundColor: this.props.color ?? "#b3071b" }}
            >
                {this.getText()}
            </Button>
        );
    }

    getText = (): string => {
        return this.props.loading ? "Aggiungo al carrello" : "Aggiungi al carrello";
    }

    getIcon = (): any => {
        if (this.props.disabled) { return <AddShoppingCart /> }
        return this.props.loading ? <CircularProgress size={24} style={{ color: "#fff" }} /> : <AddShoppingCart />;
    }

    getDisabled = (): boolean => {
        return this.props.disabled;
    }

    handlePress = () => {
        if (this.props.loading) {
            return;
        } else {
            this.props.onPress();
        }
    }

}
